import http from "@/utils/request";
//AI識別圖片，取操作者資料
export const GetScaner = (params) => {
    return http.get("/AiRecognize/GetAi_Menu", params);
};
//保存識別圖片結果
export const SaveMenu = (data) => {
    return http.post("/AiRecognize/SaveMenu", data);
};